import { render, staticRenderFns } from "./ia-w-mark.vue?vue&type=template&id=b72c1290&scoped=true&"
import script from "./ia-w-mark.vue?vue&type=script&lang=js&"
export * from "./ia-w-mark.vue?vue&type=script&lang=js&"
import style0 from "./ia-w-mark.vue?vue&type=style&index=0&id=b72c1290&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72c1290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72c1290')) {
      api.createRecord('b72c1290', component.options)
    } else {
      api.reload('b72c1290', component.options)
    }
    module.hot.accept("./ia-w-mark.vue?vue&type=template&id=b72c1290&scoped=true&", function () {
      api.rerender('b72c1290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/ia-w-mark.vue"
export default component.exports